export default "__VITE_ASSET__D9vpC7xs__"